import { PlanListParamsType, Plans, PlanType } from "@/types/Plans";
import { getConfig } from "@/utils/config";
import { HttpResponse } from "@/utils/http-client";
import useSWR from "swr";

export function useGetPlans({ type, limit, offset }: PlanListParamsType) {
  return useSWR<PlanType[], HttpResponse<any, any>>(
    "getPlans" + type + limit + offset,
    async () => {
      const params = { type, limit, offset };
      for (const key of Object.keys(params)) {
        if (!params[key as keyof typeof params]) {
          delete params[key as keyof typeof params];
        }
      }
      const plans = new Plans(getConfig());
      return (await plans.planList(params)).data;
    }
  );
}
